<div class="vohersage-table-detail-container">
  <div class="vorhersage-detail-icon" mat-subheader>
    <img style="max-height: 120px"
         src="{{datastoreService.getWetterSymbolUrl(messwerte.wettersymbol?.wert)}}"
         alt="Wettersymbol">
    <span class="vorhersage-detail-icon-description">{{messwerte.bewoelkung.text}}</span>
  </div>
  <div class="vorhersage-detail-container">
          <span class="detail-label">Lufttemperatur Min:<span
            class="detail-value"> {{werteConverter.convertDecimalWithComma(messwerte.luftTemperaturMinimum.wert)}} {{messwerte.luftTemperaturMinimum.einheit}}</span></span>
    <span class="detail-label">Lufttemperatur Max:<span
      class="detail-value"> {{werteConverter.convertDecimalWithComma(messwerte.luftTemperaturMaximum.wert)}} {{messwerte.luftTemperaturMaximum.einheit}}</span></span>
    <span class="detail-label">Gefühlte Temperatur Min:<span
      class="detail-value"> {{messwerte.gefuehlteTemperaturMinimum.wert | number: '1.0-0': 'de'}} {{messwerte.gefuehlteTemperaturMinimum.einheit}}</span></span>
    <span class="detail-label">Gefühlte Temperatur Max:<span
      class="detail-value"> {{messwerte.gefuehlteTemperaturMaximum.wert | number: '1.0-0': 'de'}} {{messwerte.gefuehlteTemperaturMaximum.einheit}}</span></span>
    <span class="detail-label">Bodentemperatur Min:<span
      class="detail-value"> {{werteConverter.convertDecimalWithComma(messwerte.bodenTemperaturMinimum.wert)}} {{messwerte.bodenTemperaturMinimum.einheit}}</span></span>
  </div>

  <div class="vorhersage-detail-container">
          <span class="detail-label">Luftdruck: <span
            class="detail-value"> {{messwerte.luftdruck.wert}} {{messwerte.luftdruck.einheit}}</span></span>
    <span class="detail-label">Luftfeuchtigkeit Min:<span
      class="detail-value"> {{messwerte.luftfeuchtigkeitMinimum.wert}} {{messwerte.luftfeuchtigkeitMinimum.einheit}}</span></span>
    <span class="detail-label">Luftfeuchtigkeit Max:<span
      class="detail-value"> {{messwerte.luftfeuchtigkeitMaximum.wert}} {{messwerte.luftfeuchtigkeitMaximum.einheit}}</span></span>
    <span class="detail-label">Taupunkt Min:<span
      class="detail-value"> {{werteConverter.convertDecimalWithComma(messwerte.taupunktMinimum.wert)}} {{messwerte.taupunktMinimum.einheit}}</span></span>
    <span class="detail-label">Taupunkt Max:<span
      class="detail-value"> {{werteConverter.convertDecimalWithComma(messwerte.taupunktMaximum.wert)}} {{messwerte.taupunktMaximum.einheit}}</span></span>
  </div>

  <div class="vorhersage-detail-container">
          <span class="detail-label">Niederschlagsmenge:<span
            class="detail-value"> {{messwerte.niederschlagsMenge.wert}} {{getQuadratmeter(messwerte.niederschlagsMenge.einheit)}}</span></span>
    <span class="detail-label">Niederschlagswahrs.:<span
      class="detail-value"> {{messwerte.niederschlagsWahrscheinlichkeit.wert}} {{messwerte.niederschlagsWahrscheinlichkeit.einheit}}</span></span>
    <span class="detail-label">Sichtweite: <span
      class="detail-value"> {{messwerte.sichtweite.wert}} {{messwerte.sichtweite.einheit}}</span></span>
    <span class="detail-label">Sonnenscheindauer: <span
      class="detail-value"> {{messwerte.sonnenscheinDauer.wert}} {{messwerte.sonnenscheinDauer.einheit}}.</span></span>
  </div>
</div>
